import React, {
    // useContext,
    // useEffect,
    // useState,
} from 'react';
import {IntlProvider} from 'react-intl';
//import {useDebounce} from 'use-debounce';

import type {ReactNode} from 'react';
import type {IntlConfig} from 'react-intl';

//import useCurrentSettings from '~/hooks/use-current-settings';
//import {AppContext} from '~/app-init';
//import {hasValue} from '~/utils/fns';

const defaultLocale = 'en-US';

type ComponentProps = {children: ReactNode | undefined} & Partial<IntlConfig>;

export const Provider = ({children, ...restProps}: ComponentProps): JSX.Element => {
    //const appCtx = useContext(AppContext);

    //const {language, locale} = useCurrentSettings();

    /* eslint-disable-next-line @typescript-eslint/no-magic-numbers */
    // const [lang] = useDebounce(language, 100);

    // const [messages, setMessages] = useState(appCtx.i18n.messages[lang]);

    // useEffect(
    //     () => {
    //         if (!hasValue(lang)) {
    //             return;
    //         }

    //         if (typeof appCtx.i18n.messages[lang] === 'undefined') {
    //             appCtx.fetchLocale(lang)
    //                 .then(data => setMessages(data));
    //         }
    //         else {
    //             setMessages(appCtx.i18n.messages[lang]);
    //         }
    //     },
    //     [
    //         appCtx,
    //         lang,
    //         setMessages,
    //     ]
    // );

    
    //TODO: Fix this file

    return (
        <IntlProvider
            defaultLocale={defaultLocale}
            locale={defaultLocale}
            messages={null}
            {...restProps}
        >
            {children}
        </IntlProvider>
    );
};

export default Provider;
